import { render, staticRenderFns } from "./iconDollar.vue?vue&type=template&id=2e1a2018&scoped=true"
import script from "./iconDollar.vue?vue&type=script&lang=js"
export * from "./iconDollar.vue?vue&type=script&lang=js"
import style0 from "./iconDollar.vue?vue&type=style&index=0&id=2e1a2018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a2018",
  null
  
)

export default component.exports